<div class="account-sites-selection-wrapper" [class.disabled-wrapper]="disabled">
  @if (filteringEnable) {
    <div class="account-search-bar mb-2">
      <div class="account-search-input-wrapper">
        <input
          type="text"
          class="k-textbox writebox account-search-input"
          placeholder="Search account name..."
          [ngModel]="_searchText"
          (ngModelChange)="_onSearchChange($event)"
          [disabled]="disabled"
        />
        @if (_searchText) {
          <i
            class="fa fa-times clear-search-icon"
            (click)="_onSearchChange('')"
            title="Clear search">
          </i>
        }
      </div>
    </div>
  }

  <kendo-grid
    [data]="_filteredAccounts"
    [kendoGridSelectBy]="'id'"
    [selectedKeys]="_selectedAccountIds"
    [selectable]="selectableSettings"
    (selectedKeysChange)="_onRowSelectionChange($event)"
    [resizable]="true"
    [loading]="_isLoading"
  >
    <kendo-grid-checkbox-column
      [title]="selectByFieldTitle"
      [width]="160"
      [resizable]="false"
      [showSelectAll]="!singleSelect && !disabled"
    >
    </kendo-grid-checkbox-column>

    <kendo-grid-column field="name" title="Account Name">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="account-name-cell">{{ dataItem.name }}</span>
      </ng-template>
    </kendo-grid-column>

    @if (enableSiteSelection) {
      <kendo-grid-column title="Sites" [width]="260">
        <ng-template kendoGridCellTemplate let-dataItem>
          <kendo-combobox
            class="current-step site-combobox w-100"
            [placeholder]="'Choose site'"
            [data]="dataItem.sites"
            textField="name"
            valueField="id"
            [(ngModel)]="dataItem.$selectedSiteId"
            [disabled]="disabled || !_isAccountSelected(dataItem.id)"
            (valueChange)="_onSiteChange($event, dataItem)"
          >
          </kendo-combobox>
        </ng-template>
      </kendo-grid-column>
    }

    <ng-template kendoGridNoRecordsTemplate>
      <div class="p-3 text-center text-muted">
        {{ _isLoading ? 'Loading accounts...' : 'No accounts found.' }}
      </div>
    </ng-template>
  </kendo-grid>
</div>
